import { gql } from '@apollo/client';

export const bookingQuery = gql`
  query booking($reference: String!, $currency: Currency) {
    booking(reference: $reference) {
      totalPriceToBePaid: totalPriceToBePaidWithCurrency(currency: $currency)
      totalPendingCreationFarePrice
      totalPendingCancellationFarePrice: totalPendingCancellationFarePriceWithCurrency(currency: $currency)
      totalExchangeFee: totalExchangeFeeWithCurrency(currency: $currency)
      totalAddonPendingCancellationFarePrice: totalAddonPendingCancellationFarePriceWithCurrency(currency: $currency)
      totalAddonPendingCreationFarePrice
      currency
      reference
      isPackage
      isMultiCurrency
      salesChannelCode
      hasBeenSoldViaThirdPartySalesChannel
      customer {
        email
      }
      hotels {
        itemRef
      }
      additionalDetails {
        value
        key
        itemRef
        passengerRef
      }
      payments(onlyProvisional: true) {
        currency
        method
        amount: amountWithCurrency(currency: $currency)
        isSuccessful
        paymentStatus
        createdRevision
        reference
      }
      cashPayments: payments(method: Cash, onlySuccessful: true) {
        currency
        method
        isSuccessful
        paymentStatus
      }
      ancillaryProduct {
        products {
          name
        }
      }
      activeImpulseUpgradeFees: impulseUpgradeFees(cancelled: false, provisional: true) {
        price
      }
      activeFlowForwardFees: flowForwardFees(cancelled: false, provisional: true) {
        price
      }
      fees {
        code
        price
        cancelled
        provisional
      }
      provisionalOfflineFees: fees(provisional: true) {
        code
        price
        cancelled
      }
      productFamilies {
        name
        code
        familyGroup
      }
      pendingCancellationLegs {
        ...leg
      }
      pendingCreationLegs {
        ...leg
      }
      outbound {
        serviceName
        serviceIdentifier
        ...leg
      }
      inbound {
        serviceName
        serviceIdentifier
        ...leg
      }
    }
  }

  fragment leg on Leg {
    ...legFields
    addOnLeg {
      ...legFields
    }
  }

  fragment passenger on Passenger {
    id
    uuid
    type
    firstName
    lastName
    email
    phoneNumber
    birthDate
    loyaltyNumber
    disabilityType
  }

  fragment legFields on Leg {
    trainNumber
    direction
    classOfService {
      code
      name
    }
    fees {
      code
      name
      price
      cancelled
      provisional
      passengerId
    }
    origin {
      name
      shortCode
      timezone
      uic
    }
    meals {
      name
      code
      passenger {
        id
      }
    }
    serviceIdentifier
    serviceName
    isSummatedFare
    serviceType {
      code
      name
      brandCode
    }
    destination {
      name
      shortCode
      uic
    }
    timing {
      departs
      arrives
      isoDate
    }
    seats {
      coach
      number
      passenger {
        id
      }
    }
    extraProducts {
      code
      price
      priceWithCurrency
      currency
      isCancelled
      provisional
      isPendingCancellation
      passengerId
      passenger {
        ...passenger
      }
      tariffDetails {
        tariffCode
        bucketCode
      }
      itemRef
      name
      type
    }
    bookingItems: products {
      itemRef
      ticketNumber
      associatedItemRefs
      passengerId
      isAFareAddOn
      price
      loyaltyPoints
      tariffDetails {
        tariffCode
        bucketCode
      }
      code
      inventoryClass
      name
      cancelled
      currency
      provisional
      canBeRebooked
      canBeCancelled
      canBeRefunded
      afterSalesRules {
        active
        validUntil
        price
        type
        currentActive
      }
      passenger {
        id
        firstName
        lastName
        type
        disabilityType
      }
      productFamily {
        code
        name
        familyGroup
      }
    }
  }
`;
